import { DrivingLicenseSituation, MinimumAges } from '..'

const situations = [
  {
    title: 'Mit kørekort er udløbet',
    text: 'eller udløber inden for 3 måneder',
    id: DrivingLicenseSituation.Renewal,
    minimumAge: MinimumAges.Adult
  },
  {
    title: 'Mit kørekort er bortkommet',
    text: 'f.eks tabt, stjålet, eller blevet væk',
    id: DrivingLicenseSituation.Lost,
    minimumAge: MinimumAges.DrivingLicenseMinor
  },
  {
    title: 'Jeg skal til udlandet',
    text: 'og jeg skal bruge et internationalt kørekort',
    id: DrivingLicenseSituation.International,
    minimumAge: MinimumAges.Adult
  },
  {
    title: 'mit kørekort er slidt/beskadiget',
    text: 'og jeg skal bruge et nyt kørekort',
    id: DrivingLicenseSituation.Damaged,
    minimumAge: MinimumAges.DrivingLicenseMinor
  },
  {
    title: 'Mit midlertidige kørekort er udløbet',
    text: 'og jeg skal bruge et nyt',
    id: DrivingLicenseSituation.TempRenewal,
    minimumAge: MinimumAges.DrivingLicenseMinor
  },
  {
    title: 'Jeg har skiftet navn',
    text: 'og jeg skal bruge et nyt kørekort',
    id: DrivingLicenseSituation.NameChange,
    minimumAge: MinimumAges.DrivingLicenseMinor
  },
  {
    title: 'Mit kørekort skal ombyttes',
    text: 'til et kreditkorttype-kørekort',
    id: DrivingLicenseSituation.Old,
    minimumAge: MinimumAges.Adult
  },
  {
    title: 'Førstegangskørekort',
    text: 'jeg skal have kørekort for første gang',
    id: DrivingLicenseSituation.FirstTimeAcquisition,
    minimumAge: MinimumAges.DrivingLicenseApplication,
    fstyr: true
  },
  {
    title: 'Udvidelse af kørekort',
    text: 'jeg skal have en ny kategori på mit kørekort',
    id: DrivingLicenseSituation.Extension,
    minimumAge: MinimumAges.DrivingLicenseMinor,
    fstyr: true
  },
  {
    title: 'Generhvervelse af kørekort',
    text: 'jeg skal generhverve mit kørekort efter frakendelse',
    id: DrivingLicenseSituation.Reinstatement,
    minimumAge: MinimumAges.DrivingLicenseMinor,
    fstyr: true
  }
]

export default situations
